import { useMutation, useQuery } from "@tanstack/react-query";

import {
  loginUser,
  logoutUser,
  forgotPassword,
  ResetPassword,
} from "../api/authService";

export const useAuth = () => {
  const login = useMutation({
    mutationFn: loginUser,
    onError: (error) => {
      console.error("Login error:", error);
    },
  });

  const logout = useQuery({
    queryKey: ["logoutUser"],
    queryFn: logoutUser,
    enabled: false,
  });

  const forgotPasswordMutation = useMutation({
    mutationFn: forgotPassword,
    onError: (error) => {
      console.error("Forgot password error:", error);
    },
  });

  const ResetPasswordMutation = useMutation({
    mutationFn: ResetPassword,
    onError: (error) => {
      console.error("Forgot password error:", error);
    },
  });

  return {
    loginUser: login.mutate,
    loginStatus: login.status,
    loginError: login.error,
    loginData: login.data,
    logoutUser: logout.refetch,
    logoutStatus: logout.status,
    logoutError: logout.error,
    logoutData: logout.data,
    forgotPassword: forgotPasswordMutation.mutate,
    forgotPasswordStatus: forgotPasswordMutation.status,
    forgotPasswordError: forgotPasswordMutation.error,
    forgotPasswordData: forgotPasswordMutation.data,
    resetPassword: ResetPasswordMutation.mutate,
    resetPasswordStatus: ResetPasswordMutation.status,
    resetPasswordError: ResetPasswordMutation.error,
    resetPasswordData: ResetPasswordMutation.data,
  };
};
